export default "__VITE_ASSET__BTwAb3Mf__"